import { Typography, Grid } from "@mui/material";
import React from "react";

import { WelcomeAdminContext } from "../context/welcomeAdminContext";
import IRatingList from "../../../ratingOverview/interface/iRatingList";
import SearchResultContent from "../../../ratingOverview/src/results/searchResultContent";
import SearchResultHeader from "../../../ratingOverview/src/results/searchResultHeader";
import StyledRatingBox from "../../../ratingOverview/styled/styledRatingBox";

const LastRatings = (): React.JSX.Element => {
  const {
    ratingList,
    setRatingList,
  }: {
    ratingList: IRatingList[];
    setRatingList: React.Dispatch<React.SetStateAction<IRatingList[]>>;
  } = React.useContext(WelcomeAdminContext);

  return (
    <React.Fragment>
      <Typography
        variant="body1"
        component="h1"
        sx={{ mb: 2, mt: 4, fontWeight: "bold", textAlign: "center" }}
      >
        Letzten 5 Bewertungen
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          {ratingList.map((rating: IRatingList) => (
            <StyledRatingBox key={rating.ratingId}>
              <SearchResultHeader
                rating={rating}
                setRatingList={setRatingList}
              />
              <SearchResultContent rating={rating} />
            </StyledRatingBox>
          ))}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default LastRatings;
